/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-max-props-per-line */
import "./footer.css";

import React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";


import { PAGE_ROUTES } from "../../utils/stateTypes";

const styles = {
  socialButton: {
    margin: "0 5px",
  },
  socialIcon: {
    width: 22,
    height: 22,
  },
  navButton: {
    display: "block",
    padding: "6px 5px",
    marginBottom: 5,
    textAlign: "left",
    minWidth: "100%",
    color: "#292a2c",
  },
};


const Footer = () => {

  return (
    <footer>
      <div className={"standard-width"}>
        <div className={"footer-top"}>
          <div className={"footer-left"}>
            <Link to={PAGE_ROUTES.HOME}>
              <div className={"footer-logo-cont"}>
                <img
                  className={"footer-logo"}
                  src={"/images/logo-1.webp"}
                  alt={"Ash The Dietitian Logo"}
                />
              </div>
            </Link>

            <p className={"footer-about"}>
              Ash is a professional dietitian with the goal of helping you create a
              balanced lifestyle. She offers in-house & online consultations to help
              you get started on your journey to a healthier you.
            </p>
          </div>

          <div className={"footer-right"}>
            <div className={"footer-right-nav"}>
              <h3 className={"footer-head"}>Navigation</h3>
              <Link to={PAGE_ROUTES.HOME}>
                <Button style={styles.navButton}>
                  Home
                </Button>
              </Link>
              <Link to={PAGE_ROUTES.SERVICES}>
                <Button style={styles.navButton}>
                  Services
                </Button>
              </Link>
              <Link to={PAGE_ROUTES.CORPORATE}>
                <Button style={styles.navButton}>
                  Corporate
                </Button>
              </Link>
              <Link to={PAGE_ROUTES.STORE}>
                <Button style={styles.navButton}>
                  Store
                </Button>
              </Link>
              <Link to={PAGE_ROUTES.CONTACT}>
                <Button style={styles.navButton}>
                  Contact
                </Button>
              </Link>
              <Link to={PAGE_ROUTES.BOOK}>
                <Button style={styles.navButton}>
                  Book a consultation
                </Button>
              </Link>
            </div>
            <div className={"footer-right-contact"}>
              <h3 className={"footer-head"}>Contact</h3>
              <Link to={PAGE_ROUTES.CONTACT}>
                <Button style={styles.navButton}>
                  ashthedietitian<span style={{ display: "none" }}>botblocker</span>@gmail.com
                </Button>
              </Link>
              <Button
                href={"tel:+27 76 271 8052"}
                style={styles.navButton}
              >
                +27 76 271 8052
              </Button>
              <Button
                href={"https://maps.app.goo.gl/kGuLUhURCNAJwBKN9"}
                target={"_blank"}
                style={styles.navButton}
              >
                V&A Waterfront, Suite 007 (Ground Floor), Granger Bay Court, Granger Road, Cape Town, 8001
              </Button>
            </div>
          </div>
        </div>

        <div className={"footer-divider"} />

        <p className={"footer-legal"}>
          Site built by <a href={"https://tap-x.com"} target={"_blank"}>TapX</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

